<template>
  <ul class="menu-nav">

    <template v-for="(item, index) in menu.aside.items">

      <li :key="index"  v-if="item.title && item.submenu"
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item menu-item-submenu"
          v-bind:class="{ 'menu-item-open': hasActiveChildren(item.page) }"
      >
        <a href="#" class="menu-link menu-toggle">
          <i class="menu-icon" :class="item.icon"></i>
          <span class="menu-text">{{ item.title }}</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="menu-submenu">
          <span class="menu-arrow"></span>
          <ul class="menu-subnav">

            <template v-for="(submenu, j) in item.submenu">


              <li :key="j" v-if="submenu.submenu"
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                  class="menu-item menu-item-submenu"
                  v-bind:class="{
              'menu-item-open': hasActiveChildren(submenu.page)
            }"
              >
                <a href="#" class="menu-link menu-toggle">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text">{{ submenu.title }}</span>
                  <i class="menu-arrow"></i>
                </a>
                <div class="menu-submenu">
                  <span class="menu-arrow"></span>
                  <ul class="menu-subnav">

                    <template v-for="(subm, t) in submenu.submenu">
                      <router-link
                          :key="t"
                          :to="subm.page"
                          v-slot="{ href, navigate, isActive, isExactActive }"
                      >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                      isActive && 'menu-item-active',
                      isExactActive && 'menu-item-active'
                    ]"
                        >
                          <a :href="href" class="menu-link" @click="navigate">
                            <i class="menu-bullet menu-bullet-dot">
                              <span></span>
                            </i>
                            <span class="menu-text">{{ subm.title }}</span>
                          </a>
                        </li>
                      </router-link>
                    </template>


                  </ul>
                </div>
              </li>

              <router-link
                  :key="j" v-else
                  :to="submenu.page"
                  v-slot="{ href, navigate, isActive, isExactActive }"
              >
                <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
                >
                  <a :href="href" class="menu-link" @click="navigate">
                    <i class="menu-bullet menu-bullet-dot">
                      <span></span>
                    </i>
                    <span class="menu-text">{{ submenu.title }}</span>
                  </a>
                </li>
              </router-link>




            </template>

          </ul>
        </div>
      </li>

      <router-link v-else-if="item.title"
          :to="item.page"
         :key="index"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
        >
          <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon" :class="item.icon"></i>
            <span class="menu-text">{{ item.title }}</span>
          </a>
        </li>
      </router-link>

      <li :key="index" v-else-if=" item.section " class="menu-section">
        <h4 class="menu-text">{{ item.section }}</h4>
      </li>

    </template>


  </ul>
</template>

<script>
import menu from "@/core/config/menu.config.json";

export default {
  name: "KTMenu",
  data() {
    return {
      menu
    };
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
